import { Course } from "./types";

// Course catalog, in display order. Lessons live under ./lessons/<courseId>/
// and reference these ids via `courseId`.
export const COURSES: Course[] = [
  {
    id: "getting-started",
    order: 1,
    title: "Getting started",
    blurb: "From your first login to an exported report: the workspace, your preferences, the recording-to-draft flow, and the iPhone app.",
    icon: "rocket",
  },
  {
    id: "reports-from-audio",
    order: 2,
    title: "Reports from audio",
    blurb: "Narrative and interaction recordings, body-cam footage and footage analysis, Axon imports, dictated additions, and what to do when an upload sticks.",
    icon: "microphone",
  },
  {
    id: "writing-and-editing",
    order: 3,
    title: "Writing and editing",
    blurb: "The editor and its side panels: statutes, snippets, polishing the draft, and organizing cases.",
    icon: "pencil",
  },
  {
    id: "your-style",
    order: 4,
    title: "Your style",
    blurb: "Make every draft sound like you with report preferences, templates, call signs, and checklists.",
    icon: "sparkles",
  },
  {
    id: "forms",
    order: 5,
    title: "Forms and files",
    blurb: "Turn department PDFs into templates the AI fills from your audio, keep recordings and documents in one library, and redact PDFs before release.",
    icon: "document-duplicate",
  },
  {
    id: "investigations",
    order: 6,
    title: "Investigations",
    blurb: "Jail calls, documents, photos, and video read in full: leads, a living brief, chat with citations, and a discovery package.",
    icon: "magnifying-glass",
    gate: "investigations",
  },
  {
    id: "policies",
    order: 7,
    title: "Policies",
    blurb: "Read and search your department's own policy manual, ask it questions, and see policy checks inside the editor.",
    icon: "shield-check",
    gate: "agency",
  },
  {
    id: "account-and-security",
    order: 8,
    title: "Account and security",
    blurb: "Account settings, billing, and multi-factor authentication.",
    icon: "cog",
  },
  {
    id: "for-agency-admins",
    order: 9,
    title: "For agency admins",
    blurb: "Run the department: seats, invites, roles, pushed preferences, MFA and SSO policy, documents, and trial findings.",
    icon: "building-office",
    gate: "admin",
  },
];
